import React from 'react';
type Badge = {
  label: string;
  content: React.ReactNode;
};
const badgeBase = 'flex h-7 flex-1 min-w-0 items-center justify-center rounded-[6px] border border-hairline bg-white px-1';
const badges: Badge[] = [{
  label: 'Visa',
  content: <span className="font-display text-[9px] font-extrabold italic tracking-tight text-[#1A1F71]" data-id="element-135" data-mp="29rugrkm47wff">
        VISA
      </span>
}, {
  label: 'Mastercard',
  content: <span className="flex items-center" data-id="element-136" data-mp="1zt51lzllsq2v">
        <span className="h-3.5 w-3.5 rounded-full bg-[#EB001B]" data-id="element-137" data-mp="1v13qwi4337ey" />
        <span className="-ml-1.5 h-3.5 w-3.5 rounded-full bg-[#F79E1B] opacity-90" data-id="element-138" data-mp="1uyqytc4m3go6" />
      </span>
}, {
  label: 'American Express',
  content: <span className="rounded-[2px] bg-[#2E77BC] px-1 py-0.5 text-[7px] font-bold tracking-tight text-white" data-id="element-139" data-mp="1m189vwnuki70">
        AMEX
      </span>
}, {
  label: 'Apple Pay',
  content: <span className="text-[9px] font-bold text-ink" data-id="element-140" data-mp="1c1hg5x74277z"> Pay</span>
}, {
  label: 'Google Pay',
  content: <span className="text-[8px] font-bold text-ink" data-id="element-141" data-mp="24nr54sg37dxp">
        <span className="text-[#4285F4]" data-id="element-142" data-mp="24mxx7o5e6idz">G</span>
        <span className="text-[#EA4335]" data-id="element-143" data-mp="29gk6d6cck451">o</span>
        <span className="text-[#FBBC05]" data-id="element-144" data-mp="29hbqnl0hufg0">o</span>
        <span className="text-[#34A853]" data-id="element-145" data-mp="1urnuszb308zo">g</span>
        <span className="text-[#4285F4]" data-id="element-146" data-mp="1uorwh9vbniap">l</span>
        <span className="text-[#EA4335]" data-id="element-147" data-mp="1zqqv66g49r1b">e</span> Pay
      </span>
}, {
  label: 'Shop Pay',
  content: <span className="rounded-[2px] bg-[#5A31F4] px-1 py-0.5 text-[7px] font-bold tracking-tight text-white" data-id="element-148" data-mp="2nftgbo9ym20k">
        shop
      </span>
}];
export function PaymentIcons() {
  return <ul className="flex w-full items-center justify-center gap-1.5" aria-label="Accepted payment methods" data-id="element-149" data-mp="2dgkmcvf3gne7">
      {badges.map(badge => <li key={badge.label} className={badgeBase} title={badge.label} data-id="element-150" data-mp="121fj9qb1wmu2">
          <span className="sr-only" data-id="element-151" data-mp="124a1rcai7xku">{badge.label}</span>
          <span aria-hidden="true" className="flex items-center justify-center" data-id="element-152" data-mp="171teg7rk02ao">
            {badge.content}
          </span>
        </li>)}
    </ul>;
}